module.exports = __webpack_public_path__ + "img/gold_slot_rich.67940cbb.png";